import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['profileButton', 'dropdownContent', 'hamburgerMenu', 'hamburgerMenuContent'];

  connect() {
    this.active = false;
  }

  toggleDropdown() {
    this.active = !this.active;
    this.dropdownContentTarget.style.display = this.active ? 'block' : 'none';
    this.profileButtonTarget.setAttribute('aria-expanded', this.active);
  }

  clearDropdown() {
    this.active = false;
    this.dropdownContentTarget.style.display = 'none';
    this.profileButtonTarget.setAttribute('aria-expanded', 'false');
  }

  closeDropdown() {
    this.active = false;
    this.dropdownContentTarget.style.display = 'none';
    this.profileButtonTarget.setAttribute('aria-expanded', 'false');
    this.profileButtonTarget.focus();
  }

  handleKeydown(event) {
    const currentItem = document.activeElement;

    if (event.key === 'Escape') {
      this.closeDropdown();
    } else if (event.key === 'Enter' || event.key === ' ') {
      if (currentItem.role !== 'menuitem') {
        event.preventDefault();
      }
      this.toggleDropdown();
    }
  }

  toggleHamburgerMenu() {
    this.active = !this.active;
    this.hamburgerMenuContentTarget.style.display = this.active ? 'block' : 'none';
    this.hamburgerMenuTarget.setAttribute('aria-expanded', this.active);
  }

  closeHamburgerMenu() {
    this.active = false;
    this.hamburgerMenuContentTarget.style.display = 'none';
    this.hamburgerMenuTarget.setAttribute('aria-expanded', 'false');
  }
}
